import { keyById } from '@Ravnur-Inc/nanoutils/keyBy';
import { LiveEvent$Status } from '@Ravnur-Inc/shared/types/Live';

import { FieldDescription$ThesaurusDescription } from '@/types/FieldDescription';

export const AUTO_START: FieldDescription$ThesaurusDescription = [
  { id: 'true', tkey: 'auto-start__on' },
  { id: 'false', tkey: 'auto-start__off' },
];

export const STATUSES: FieldDescription$ThesaurusDescription<LiveEvent$Status> = [
  { id: LiveEvent$Status.EXPIRED, tkey: 'status__expired', badge: 'warning' },
  { id: LiveEvent$Status.ON_AIR, tkey: 'status__on-air', badge: 'danger' },
  { id: LiveEvent$Status.PREVIEW, tkey: 'status__preview', badge: 'warning' },
  {
    id: LiveEvent$Status.SCHEDULED,
    tkey: 'status__scheduled',
    badge: 'success',
  },
  { id: LiveEvent$Status.FINISHED, tkey: 'status__finished', badge: 'grey' },
];

export const STATUSES_AS_CACHE = keyById(STATUSES);
